import React from "react";

export const Crown = ({ className = "", color = "#FF2E93" }) => (
    <svg
        viewBox="0 0 64 48"
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        aria-hidden="true"
    >
        <path
            d="M4 42 L12 8 L24 30 L32 4 L40 30 L52 8 L60 42 Z"
            fill={color}
            stroke="#000"
            strokeWidth="3"
            strokeLinejoin="miter"
        />
        <circle cx="12" cy="8" r="4" fill="#000" />
        <circle cx="32" cy="4" r="4" fill="#000" />
        <circle cx="52" cy="8" r="4" fill="#000" />
    </svg>
);
